module.exports = "/_next/static/images/award-line-3414d5f9ea527f7ecf28b46bb56b023c.svg";